import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import addVisibilityObserver from '@/js/components/useVisibilityObserver';
import BaseComponent from './baseComponent';

gsap.registerPlugin(ScrollTrigger);

export default class ContentBenefits extends BaseComponent {
  /**
   * Public constructor
   *
   * @param options
   */
  constructor(options) {
    super(options);
    this.el = document.querySelector('[data-content-benefits]');
    this.debug = false;
  }

  init() {
    if (!this.el) {
      return;
    }

    addVisibilityObserver(this.el, {
      onFirstEnter: () => {
        if (document.querySelector('[data-header-hero-full-background]')) {
          setTimeout(() => {
            console.log('ContentBenefits initialised after HeaderHeroFullBackground');
            this.animation();
          }, 800);
        } else {
          console.log('ContentBenefits initialised');
          this.animation();
        }
      },
    }, {
      threshold: 0,
    });
  }

  animation() {
    const mm = gsap.matchMedia();

    mm.add('(max-width: 991px)', () => {
      this.el.classList.remove('-animated-version');
    });

    // The following scroll-animation only runs on viewport large
    mm.add('(min-width: 992px)', () => {
      this.el.classList.add('-animated-version');

      const items = [...this.el.querySelectorAll('.card')];
      const itemCount = items.length;
      const duration = (itemCount * 333); // 333 per card

      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: this.el,
          markers: this.debug,
          start: () => 'top top',
          end: () => `+=${duration}`,
          pin: true,
          pinSpacing: true,
          scrub: 0.5, // true or seconds
        },
      });

      items.forEach((item, index) => {
        // Do nothing with the first card
        if (index > 0) {
          timeline.from(item, { translateY: '100vh', duration: 20 }, '<-=19.5');
        }

        // Scale down if not last item
        if (index < (itemCount - 1)) {
          timeline
            .to(item, { scale: 0.95, duration: 20 })
            .to(item, { opacity: 0, duration: 0.5 }, '>');
        }
      });

      ScrollTrigger.refresh();

      window.addEventListener('resize', () => ScrollTrigger.refresh());
      window.addEventListener('load', () => ScrollTrigger.refresh());
    });

    return this;
  }
}
